// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-modal ion-toolbar{--min-height:86px;--border-width:0!important}.base-modal__header__subtitle{font-size:14px;color:var(--ion-color-secondary-tint)}.base-modal__header__button,.base-modal__header__icons{-webkit-margin-end:15px;margin-inline-end:15px}.base-modal__header__button:enabled span,.base-modal__header__icons:enabled span{color:#78a6b8}", ""]);
// Exports
module.exports = exports;
